
import searchService from "@/services/search.service"
const debounce = require("lodash.debounce")
import { mdiSend, mdiMapMarker, mdiMagnify } from "@mdi/js"
import OabatTextFieldSearchIcon from "@/components/base/design/OabatTextFieldSearchIcon"

export default {
    name: "LocationInputCombobox",
    components: { OabatTextFieldSearchIcon },
    props: {
        label: {
            type: String,
            default: () => {
                return `Gib z.B. Passau oder 94032 ein`
            },
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: mdiMagnify,
        },
        /** Attaches the v-menu to the combobox to enforce opening it to the bottom. Results in scrolling behaviour on parent component */
        attach: {
            type: Boolean,
            default: false,
        },
        /** Disables location hints */
        noHint: {
            type: Boolean,
            default: false,
        },
        /** Remvoes nearby selection */
        noNearby: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            mdiMapMarker,
            mdiSend,
            snackbar: false,
            loading: false,
            items: [],
            search: null,
            select: null,
            autocomplete: null,
            hasFocus: false,
            debouncedSearch: debounce(this.performSearch, 300, {
                leading: false,
                trailing: true,
            }),
            attachElement: undefined,
            isRequestingLocation: false,
            hasNoGeoLocation: false,
            noResult: true,
            searchMatchFilter: (item, queryText, itemText) => {
                return (
                    itemText
                        .trim()
                        .toLocaleLowerCase()
                        .indexOf(queryText.trim().toLocaleLowerCase()) > -1
                )
            },
        }
    },
    computed: {
        itemsLocation() {
            if ((!this.search || this.items.length === 0) && !this.noNearby) {
                return [
                    // { name: "In meiner Region suchen", slug: "nearby", id: 0 },
                ]
            }
            return this.items.slice(0, 5)
        },
    },
    watch: {
        search(newVal) {
            if (newVal) {
                this.noResult = false
                this.debouncedSearch(newVal)
            }
        },
        value(val) {
            this.search = val
        },
    },
    mounted() {
        this.attachElement = this.attach ? this.$refs.location?.$el : undefined
    },
    methods: {
        async onSearchNearbyClick() {
            await this.setLocation({
                name: "In meiner Region suchen",
                slug: "nearby",
            })
        },
        async performSearch(search) {
            search = search.trim()
            this.loading = true
            if (search.length !== 0) {
                const result = await searchService.autocompleteCity(search)
                this.items = result.items
                this.noResult = result.items.length === 0
            } else {
                this.items = []
                this.noResult = true
            }
            this.loading = false
        },
        clear() {
            this.items = []
            this.search = null
            this.select = null
        },
        setFocus(value) {
            this.hasFocus = value
            this.$emit("focus", value)
            if (!value) {
                this.$refs["location"]?.blur()
            }
        },
        getCurrentLocation() {
            if (navigator.geolocation) {
                let hintDelay = setTimeout(
                    () => (this.isRequestingLocation = true),
                    100
                )
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const location = {
                            name: "Umgebung",
                            slug: "nearby",
                            longitude: position.coords.longitude,
                            latitude: position.coords.latitude,
                        }
                        clearTimeout(hintDelay)
                        this.isRequestingLocation = false
                        this.setFocus(false)
                        this.$emit("input", location)
                    },
                    () => {
                        this.isRequestingLocation = false
                        clearTimeout(hintDelay)
                        this.snackbar = true
                        this.setFocus(false)
                    },
                    { enableHighAccuracy: true, maximumAge: 10000 }
                )
            } else {
                this.hasNoGeoLocation = true
            }
        },
        async setLocation(input) {
            if (!input || !input.slug) return
            if (input.slug === "nearby") {
                this.getCurrentLocation()
                return
            }

            const location = await searchService.getLocationFromSlug(input.id)

            this.setFocus(false)
            this.$emit("input", location)
        },
        focus() {
            setTimeout(() => {
                this.setFocus(true)
                this.$refs.location.onFocus()
                this.$refs.location.activateMenu()
            }, 300)
        },
    },
}
